import { useEffect, useState } from "react";
import { Send, QrCode, Briefcase, Sparkles, ShieldCheck, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEY = "cashisle.tour.v1";

const STEPS = [
  {
    icon: Send,
    title: "Send & request, instantly",
    body: "Move money to anyone with a $cashtag in seconds — no bank details needed.",
  },
  {
    icon: QrCode,
    title: "Scan to pay merchants",
    body: "Snap a QR or share yours to receive. Approved vendors show up on Discover.",
  },
  {
    icon: Briefcase,
    title: "Earn from gigs",
    body: "Post or claim local work. Payment is held in escrow and released on delivery.",
  },
  {
    icon: ShieldCheck,
    title: "Verify to unlock more",
    body: "Add ID & a selfie to raise your sending and payout limits and earn a trust tier.",
  },
  {
    icon: Sparkles,
    title: "Spin daily, win prizes",
    body: "Three free spins every day for points and cash. Stack rewards as you hustle.",
  },
];

export const OnboardingTour = () => {
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!localStorage.getItem(KEY)) setOpen(true);
  }, []);

  const close = () => {
    localStorage.setItem(KEY, "1");
    setOpen(false);
  };

  if (!open) return null;
  const S = STEPS[step];
  const isLast = step === STEPS.length - 1;

  return (
    <div className="fixed inset-0 z-50 grid place-items-end sm:place-items-center bg-black/60 backdrop-blur-sm animate-fade-in">
      <div className="w-full sm:max-w-sm bg-card border border-border rounded-t-3xl sm:rounded-3xl p-6 shadow-2xl animate-fade-in-up">
        <div className="flex justify-between items-start mb-4">
          <div className="h-12 w-12 rounded-2xl bg-primary/15 grid place-items-center text-primary">
            <S.icon className="h-6 w-6" />
          </div>
          <button
            onClick={close}
            aria-label="Skip tour"
            className="h-8 w-8 grid place-items-center rounded-full hover:bg-muted text-muted-foreground"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <h2 className="font-display font-extrabold text-xl">{S.title}</h2>
        <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{S.body}</p>

        <div className="mt-5 flex items-center justify-center gap-1.5">
          {STEPS.map((_, i) => (
            <span
              key={i}
              className={`h-1.5 rounded-full transition-all ${
                i === step ? "w-6 bg-primary" : "w-1.5 bg-muted"
              }`}
            />
          ))}
        </div>

        <div className="mt-6 flex gap-2">
          {step > 0 && (
            <Button variant="ghost" className="flex-1" onClick={() => setStep((s) => s - 1)}>
              Back
            </Button>
          )}
          <Button
            className="flex-1"
            onClick={() => (isLast ? close() : setStep((s) => s + 1))}
          >
            {isLast ? "Let's go" : "Next"}
          </Button>
        </div>

        {!isLast && (
          <button
            onClick={close}
            className="block mx-auto mt-3 text-xs text-muted-foreground hover:underline"
          >
            Skip tour
          </button>
        )}
      </div>
    </div>
  );
};
